import Row from 'components/drafts/Row/Row'
import Footer from 'components/items/Footer/Footer'
import {
  DecodedQueryParamFilters,
  SetQueryParamFilters,
} from 'components/items/FilterParams'

import EmptyList from './EmptyList/EmptyList'
import DraftBanner from '../DraftBanner/DraftBanner'
import s from './List.module.css'

type Props = {
  projectId: string
  projectDrafts: ProjectTemplateList[]
  queryParamFilters: DecodedQueryParamFilters
  totalDrafts: number
  setQueryParamFilters: SetQueryParamFilters
  toggleDraftsView: () => void
  refetchDrafts: () => void
}

const List = ({
  projectDrafts,
  totalDrafts,
  queryParamFilters,
  setQueryParamFilters,
  toggleDraftsView,
  refetchDrafts,
  projectId,
}: Props) => {
  const { stage, rework, vertical, assignee, status } = queryParamFilters
  const isNoFilterApplied =
    assignee.length === 0 &&
    status.length === 0 &&
    !stage &&
    !rework &&
    !vertical

  return (
    <>
      <DraftBanner
        totalDrafts={projectDrafts.length}
        onShowAllDrafts={toggleDraftsView}
      />
      {projectDrafts.length > 0 ? (
        <div className={s.list}>
          {projectDrafts?.map((draft: ProjectTemplateList) => (
            <Row
              key={draft.id}
              draft={draft}
              refetchDrafts={refetchDrafts}
              projectId={projectId}
            />
          ))}

          <Footer
            total={totalDrafts}
            queryParamFilters={queryParamFilters}
            setQueryParamFilters={setQueryParamFilters}
          />
        </div>
      ) : projectDrafts.length === 0 && isNoFilterApplied ? (
        <div className={s.emptyList}>
          <EmptyList />
        </div>
      ) : (
        <div className={s.emptyList}>No results found</div>
      )}

      {/* <BottomPopup
          drafts={drafts}
          refetchDrafts={refetchDrafts}
          selectedDraftsVertical={selectedDraftsVertical}
        /> */}
    </>
  )
}

export default List
